import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner, Alert, Table } from 'react-bootstrap';
import * as XLSX from 'xlsx';

const ExcelViewerModal = ({ show, onHide, excelUrl, docName }) => {
    const [sheetData, setSheetData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (show && excelUrl) {
            setLoading(true);
            setError('');
            fetch(excelUrl)
                .then(res => res.arrayBuffer())
                .then(arrayBuffer => {
                    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                    setSheetData(data);
                    setLoading(false);
                })
                .catch(() => {
                    setError('Erro ao ler o arquivo Excel');
                    setLoading(false);
                });
        } else {
            setSheetData([]);
        }
    }, [show, excelUrl]);

    return (
        <Modal show={show} onHide={onHide} size="xl" centered dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title>Visualizando: {docName}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '80vh', overflowY: 'auto' }}>
                {loading && <Spinner animation="border" />}
                {error && <Alert variant="danger">{error}</Alert>}
                {!loading && !error && sheetData.length > 0 && (
                    <Table striped bordered hover responsive>
                        <tbody>
                            {sheetData.map((row, i) => (
                                <tr key={i}>
                                    {row.map((cell, j) => (
                                        <td key={j}>{cell}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
                {!loading && !error && sheetData.length === 0 && <div>Nenhum dado encontrado na planilha.</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ExcelViewerModal; 